<ng-container
	*ngIf="{
		loading: loading$ | async,
	} as viewData"
>
	<div class="auth-container">
		<sf-auth-top-bar></sf-auth-top-bar>
		<div class="card auth-content">
			<div class="auth-content-inner">
				<div *ngIf="!viewData.loading; else loader">
					<h3 class="sf title">{{ title | async | translate }}</h3>
					<span class="caption">{{ label | async | translate }}</span>
					<button
						*ngIf="showButton"
						class="create-account"
						mat-flat-button
						color="accent"
						[routerLink]="[RoutePath.AUTH, RoutePath.SIGN_UP] | fullUrl"
					>
						{{ 'sf.module.auth.log_in.create_account' | translate | uppercase }}
					</button>
					<div class="separator"></div>
					<div class="back-to-login-wrapper">
						<span class="link" routerLink="/">{{ 'sf.module.auth.common.back_to_login' | translate }}</span>
					</div>
				</div>
			</div>
		</div>
		<sf-contact-footer></sf-contact-footer>
	</div>
</ng-container>

<ng-template #loader>
	<div class="loader"><mat-spinner color="accent" [diameter]="80"></mat-spinner></div>
</ng-template>
